import {getVoiceFilterById} from '@Panels/ai-voice-panel/ai-voice-panel.library';

export const getAvatarUrlForVoice = (idVoice: number): string | undefined => {
  return getVoiceFilterById(idVoice)?.avatarUrl;
};
